
import { Options, prop, Vue } from "vue-class-component";
import Checkbox from "primevue/checkbox";
import ModalDetailProductKulioner from "./modal-detail-product.vue";
import moment from "moment";
import {
  formatPriceRP,
  parsingErrorResponse,
  CLIENT_ERROR,
  formatTimeCustom
} from "@/app/infrastructures/misc/Utils";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { KulionerController } from "@/app/ui/controllers/KulionerController";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { PrintDataEntitas, ShipmentId } from "@/domain/entities/Booking";
import { ShipmentBookingController } from "@/app/ui/controllers/ShipmentBookingController";
import { ShipmentInstantBooking } from "@/data/payload/api/ShipmentBookingRequest";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";
import { KulionerMerchant, KulionerOrder } from "@/domain/entities/Kulioner";
import ModalSuccessProcessOrder from "../components/modal-success-process-order.vue";
import { ErrorMessageEntities } from "@/domain/entities/MainApp";
import generatePrintReceipt from "./receipt";
import ModalProcessKulioner from "./ModalProcessKulioner.vue";
import generateKulionerBulkLabelResiThermal from "../modules/kulioner-bulk-label-resi-thermal";
import JsBarcode from "jsbarcode";

class Props {
  isCheckable = prop<boolean>({
    default: false,
    type: Boolean
  });
  isChecked = prop<boolean>({
    default: false,
    type: Boolean
  });
  data = prop<KulionerOrder>({
    required: true
  });
}
@Options({
  components: {
    Checkbox,
    ModalDetailProductKulioner,
    ModalSuccessProcessOrder,
    ModalProcessKulioner
  },
  emits: ["check", "uncheck", "successProcessOrder"]
})
class CardListKulioner extends Vue.with(Props) {
  isMarkProcess = this.data.isMarkProcessed;
  isShowModalPopupDetail = false;
  isError = false;
  isErrorCause = "";
  sttId = 0;
  successProcessResponse = new ResponsePayload();
  isShowSuccessProcessModal = false;
  isLoadingBtn = false;
  sttProductType = "";
  isShowModalProcessKulioner = false;
  isShowModalAcceptOrder = false;
  isShowModalFailedOrder = false;
  dataKulioner = [this.data];
  isLoadingProcessOrder = false;
  isShowMoreMerchant = false;

  get slicedMerchant() {
    if (this.isShowMoreMerchant) {
      return this.data.merchants;
    }

    return this.data.merchants.slice(0, 3);
  }

  get showButtonShowMoreMerchant() {
    return this.showOtherMerchant && !this.isShowMoreMerchant;
  }

  get showButtonShowLessMerchant() {
    return this.showOtherMerchant && this.isShowMoreMerchant;
  }

  onClickShowMoreMerchant() {
    this.isShowMoreMerchant = true;
  }

  onClickShowLessMerchant() {
    this.isShowMoreMerchant = false;
  }

  onCloseModal(value: boolean) {
    this.$emit("update:modelValue", value);
  }

  closeModalSuccess() {
    this.$emit("successProcessOrder");
  }

  onSuccess() {
    this.closeModalOrderKulioner();
    this.isShowModalAcceptOrder = true;
  }

  onFailed() {
    this.closeModalOrderKulioner();
    this.isShowModalFailedOrder = true;
  }

  closeModalOrderKulioner() {
    this.isShowModalProcessKulioner = false;
  }

  async onChangeTogggleProcessed() {
    this.isMarkProcess = this.data.isMarkProcessed;
    try {
      MainAppController.showLoading();
      await KulionerController.updateToggle(this.data.id);
    } catch (error) {
      this.isError = true;
      this.isErrorCause = parsingErrorResponse(error).type;
    } finally {
      MainAppController.closeLoading();
    }
  }
  setValueCheckbox() {
    if (this.isChecked) {
      this.$emit("uncheck", this.data);
      return;
    }
    this.$emit("check", this.data);
  }

  listStt: PrintDataEntitas[] = [];
  
  async getDetailStt(sttNo: string) {
    try {
      const listStt = await KulionerController.getListStt({
        page: 1,
        limit: 50,
        destinationCityId: 0,
        userType: "",
        bookedBy: "",
        bookedType: "",
        fromDate: "",
        endDate: "",
        sttNumber: sttNo
      });

      const listOrder = await KulionerController.getKulionerDetail(
        this.data.id
      );

      this.listStt = [
        new PrintDataEntitas({
          ...listStt[0],
          orderDetail: listOrder
        })
      ]
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, "Gagal Print resi!")
      );
      throw err;
    }
  }

  async printBulkReceipt() {
    const listBulkStt: PrintDataEntitas[] = await this.generateDataResi();
    if (!listBulkStt.length) return;

    new Promise(function(resolve) {
      MainAppController.showLoading();
      setTimeout(resolve.bind(null, null), 1);
    }).then(() => {
      const accountType = AccountController.accountData.account_type;
      generateKulionerBulkLabelResiThermal({
        data: listBulkStt,
        accountType
      });

      MainAppController.closeLoading();
    });
  }

  async generateDataResi() {
    const list: PrintDataEntitas[] = [];

    await new Promise((resolve) => {
      this.listStt.forEach((item, index) => {
        if (item) {
          const barcode = document.createElement("img");
          const vendorBarcode = document.createElement("img");
          JsBarcode(barcode, item.sttNo, {
            textAlign: "left",
            displayValue: false,
            fontSize: 16
          });
          if (item.sttVendorRefferenceNo) {
            // vendor ref code
            JsBarcode(vendorBarcode, item.sttVendorRefferenceNo, {
              textAlign: "left",
              displayValue: false,
              fontSize: 16
            });
          }

          item.sttPieces.forEach((e) => {
            list.push(
              new PrintDataEntitas({
                ...e,
                ...item,
                barcode: barcode.src,
                vendorRefCode: vendorBarcode.src
              })
            );
          });

          barcode.remove();
          vendorBarcode.remove();
        }

        if (this.listStt.length - 1 === index) {
          resolve(true);
        }
      });
    });

    return list;
  }

  async onPrintReceipt(sttNo: string) {
    try {
      MainAppController.showLoading();
      await this.getDetailStt(sttNo);
      await this.printBulkReceipt();
    } finally {
      MainAppController.closeLoading();
    }
  }

  isLoadingDownloadOrder = false;

  async onDownloadOrder() {
    this.isLoadingDownloadOrder = true;
    try {
      const detailedOrder = await KulionerController.getKulionerDetail(
        this.data.id
      );
      console.log(
        "🚀 ~ CardListKulioner ~ onDownloadOrder ~ detailedOrder:",
        JSON.stringify(detailedOrder)
      );
      await generatePrintReceipt([detailedOrder]);
    } catch (error) {
      console.error("Error fetching detailed order for download:", error);
    } finally {
      this.isLoadingDownloadOrder = false;
    }
  }

  onAcceptOrder() {
    // action accept order
    this.isShowModalProcessKulioner = true;
  }

  onTrackingOrder() {
    window.open(`/shipment/tracking/stt?stt-no=${this.data.orderSttNo}`);
  }

  showModalPopupDetailProduct() {
    this.isShowModalPopupDetail = true;
  }

  onCloseModalPopupDetailProduct() {
    this.isShowModalPopupDetail = false;
  }

  mapOrderStatus(status: string) {
    const statusMap: any = {
      ORDWTC: {
        label: "Pesanan baru",
        color: "bg-yellow-lp-200",
        textColor: "text-yellow-lp-100"
      },
      ORDPRC: {
        label: "Pesanan diproses",
        color: "bg-blue-lp-200",
        textColor: "text-blue-lp-300"
      },
      ORDBKD: {
        label: "Pesanan perlu dikirim",
        color: "bg-aqua-lp-200",
        textColor: "text-aqua-lp-500"
      },
      ORDDLV: {
        label: "Pesanan dikirim",
        color: "bg-purple-lp-100",
        textColor: "text-purple-lp-800"
      },
      ORDRCV: {
        label: "Pesanan selesai",
        color: "bg-green-lp-300",
        textColor: "text-green-lp-400"
      },
      CNCWRF: {
        label: "Pesanan dibatalkan",
        color: "bg-red-lp-600",
        textColor: "text-red-lp-300"
      }
    };

    return (
      statusMap[status] || {
        label: "status tidak dikenal",
        color: "bg-gray-200",
        textColor: "text-gray-300"
      }
    );
  }
  statusInfo = this.mapOrderStatus(this.data.status);
  get formatDate() {
    return moment(this.data.createdAt).format("DD MMMM YYYY, HH:mm");
  }

  mapProductLogo(productCode: string) {
    const logoMap: any = {
      REGPACK: require("@/app/ui/assets/svg/product-logo/regpack-active.svg"),
      MINIPACK: require("@/app/ui/assets/svg/product-logo/minipack-active.svg"),
      BOSSPACK: require("@/app/ui/assets/svg/product-logo/bosspack-active.svg"),
      INTERPACK: require("@/app/ui/assets/svg/product-logo/interpack-active.svg"),
      JAGOPACK: require("@/app/ui/assets/svg/product-logo/jagopack-active.svg"),
      JUMBOPACK: require("@/app/ui/assets/svg/product-logo/jumbopack-active.svg"),
      JUMBOPACKH2H: require("@/app/ui/assets/svg/product-logo/jumbopackh2h-active.svg"),
      ONEPACK: require("@/app/ui/assets/svg/product-logo/onepack-active.svg"),
      OTOPACK150: require("@/app/ui/assets/svg/product-logo/otopack-150-active.svg"),
      OTOPACK250: require("@/app/ui/assets/svg/product-logo/otopack-250-active.svg"),
      SAMEDAY: require("@/app/ui/assets/svg/product-logo/sameday-active.svg"),
      BIGPACK: require("@/app/ui/assets/svg/product-logo/bigpack-active.svg")
    };

    return logoMap[productCode] || null;
  }

  formatPrice(val: any) {
    return formatPriceRP(val);
  }

  get showOtherMerchant() {
    return this.data.totalMerchant - 3 > 0;
  }

  get showButtonPrintResi() {
    return ["ORDBKD", "ORDDLV", "ORDRCV"].includes(this.data.status);
  }

  get showButtonTracking() {
    return ["ORDBKD", "ORDDLV"].includes(this.data.status);
  }

  onClickDetail() {
    this.$router.push(`/kulioner/detail/${this.data.id}`);
  }

  async onProcessOrder() {
    if (this.isLoadingProcessOrder) return;
    if (this.data.orderShipmentId.startsWith("AD")) {
      try {
        this.isLoadingProcessOrder = true;
        MainAppController.showLoading();
        const res = await KulionerController.getShipmentIdList(
          this.data.orderShipmentId
        );
        this.addShipmentToBook(res.data);
      } catch (err) {
        MainAppController.closeLoading();
        this.isLoadingProcessOrder = false;
        this._showErrorProcessOrder(err);
      }
    }
  }

  addShipmentToBook(data: any) {
    if (data.length > 0) {
      for (const row of data) {
        this.onProcessBook(row);
      }
      return;
    }
  }

  async onProcessBook(detail: ShipmentId) {
    this.addInstantBooking(detail);
  }

  get originDistrict() {
    const detail = LocationController.districtDetail;
    return {
      id: detail.id,
      name: `${detail.name}, ${detail.cityName}`,
      code: `${detail.code}`,
      cityCode: `${detail.cityCode}`,
      ursaCode: detail.ursaCode,
      cityId: detail.cityId,
      cityName: detail.cityName
    };
  }

  get dataProfile() {
    return AccountController.accountData;
  }

  mappingSttPieces(shipment: any) {
    return shipment.shipmentGoodDetail.length
      ? shipment.shipmentGoodDetail.map((pieces: any) => ({
          // eslint-disable-next-line @typescript-eslint/camelcase
          stt_piece_length: pieces.shipment_goods_length,
          // eslint-disable-next-line @typescript-eslint/camelcase
          stt_piece_width: pieces.shipment_goods_width,
          // eslint-disable-next-line @typescript-eslint/camelcase
          stt_piece_height: pieces.shipment_goods_height,
          // eslint-disable-next-line @typescript-eslint/camelcase
          stt_piece_gross_weight: pieces.shipment_goods_weight
        }))
      : [];
  }

  payloadSttOne(shipment: ShipmentId) {
    return {
      sttNo: "",
      sttShipmentId: shipment.shipmentAlgoId,
      sttTaxNumber: "",
      sttGoodsEstimatePrice: shipment.shipmentGoodsPriceEstimation,
      sttGoodsStatus: shipment.shipmentGoodsStatus,
      sttNoRefExternal: shipment.shipmentBookingId.startsWith("TSLP")
        ? shipment.shipmentBookingId
        : "",
      sttOriginCityId: this.originDistrict.cityCode,
      sttDestinationCityId: shipment.shipmentDestinationCity?.code,
      sttOriginDistrictId: this.originDistrict.code
    };
  }

  payloadSttTwo(shipment: ShipmentId) {
    this.sttProductType = shipment.shipmentProduct;
    return {
      sttDestinationDistrictId: shipment.shipmentDestinationDistrict?.code,
      sttSenderName: shipment.shipmentSenderName,
      sttSenderPhone: shipment.senderPhoneInstantBooking,
      sttSenderAddress: shipment.shipmentSenderAddress,
      sttRecipientName: shipment.shipmentRecipientName,
      sttRecipientPhone: shipment.recipientPhoneInstantBooking,
      sttRecipientAddress: shipment.shipmentRecipientAddress,
      sttProductType: shipment.shipmentProduct,
      sttCommodityCode: shipment.shipmentCommodityCode || "GEN",
      sttInsuranceType: shipment.shipmentInsurance
    };
  }

  payloadSttThree(shipment: ShipmentId) {
    return {
      sttIsDo: shipment.isDO,
      sttIsCod: shipment.shipmentIsCod,
      sttIsDfod: shipment.shipmentIsDfod,
      sttCodFee: shipment.codFee,
      sttCodAmount: shipment.codAmount,
      sttPieces: this.mappingSttPieces(shipment),
      postalCodeDestination: shipment.postalCodeDestination,
      addressReceiverType: "home",
      sttWoodpacking: shipment.shipmentIsWoodpacking,
      sttAttachFiles: [],
      sttRecipientEmail: "",
      sttKtpImage: "",
      sttTaxImage: "",
      sttInterTaxNumber: "",
      sttIdentityNumber: "",
      sttCipl: []
    };
  }

  mappingPayloadStt(shipment: any) {
    return {
      ...this.payloadSttOne(shipment),
      ...this.payloadSttTwo(shipment),
      ...this.payloadSttThree(shipment)
    };
  }

  async addInstantBooking(shipment: ShipmentId) {
    const accountTypeDetail = this.dataProfile.account_type_detail || {};
    await ShipmentBookingController.addInstantBooking(
      new ShipmentInstantBooking({
        shipmentPackageId: shipment.shipmentPacketId,
        stt: this.mappingPayloadStt(shipment),
        districtOrigin: {
          id: this.originDistrict.id,
          code: this.originDistrict.code,
          name: this.originDistrict.name,
          ursaCode: this.originDistrict.ursaCode,
          city: {
            id: this.originDistrict.cityId,
            code: this.originDistrict.cityCode,
            name: this.originDistrict.cityName
          }
        },
        districtDestination: {
          id: shipment.shipmentDestinationDistrict.id,
          code: shipment.shipmentDestinationDistrict.code,
          name: shipment.shipmentDestinationDistrict.name,
          ursaCode: shipment.shipmentDestinationDistrict.ursa_code,
          isCod: "",
          status: "",
          type: "",
          city: {
            id: shipment.shipmentDestinationCity.id,
            code: shipment.shipmentDestinationCity.code,
            name: shipment.shipmentDestinationCity.name
          }
        },
        commodity: {
          commodityId: shipment.shipmentCommodityId,
          commodityCode: shipment.shipmentCommodityCode,
          commodityName: shipment.shipmentCommodityName,
          commodityDocumentSurcharge:
            shipment.shipmentCommodityDocumentSurcharge,
          hsCode: shipment.shipmentCommodityHsCode
        },
        partner: {
          id: accountTypeDetail.id,
          name: accountTypeDetail.company_name,
          code: accountTypeDetail.code,
          partnerExternalCode: this.dataProfile.account_type_detail
            ?.partnerExternalCode,
          partnerLocation: {
            id: accountTypeDetail.partnerLocation?.id,
            districtCode: accountTypeDetail.partnerLocation?.district_code
          },
          partnerLocationList: []
        }
      })
    )
      .then((res: ResponsePayload) => {
        this.successProcessResponse = res;
        this.isShowSuccessProcessModal = true;
      })
      .catch((error: any) => {
        // open modal error
        this._showErrorProcessOrder(error);
      })
      .finally(() => {
        MainAppController.closeLoading();
        this.isLoadingProcessOrder = false;
      });
  }

  _showErrorProcessOrder(error: any) {
    MainAppController.showErrorMessage(
      new ErrorMessageEntities({
        title: "Booking gagal",
        message: error.response.data?.message?.id || "",
        type: CLIENT_ERROR,
        buttonSuccessText: "Oke, mengerti",
        onClose: () => {
          MainAppController.closeErrorMessage();
        }
      })
    );
  }

  mapCycleTime(time: string) {
    const [hour, minute] = time ? time.split(":") : "";
    const formattedTime = `Cycle ${hour}.${minute}`;
    const label = time ? formattedTime : "-";
    const textColor = [
      "#CD4425",
      "#4D4D4D",
      "#2468F6",
      "#FAB713",
      "#51B6D5",
      "#6257BA",
      "#36B37E",
      "#B53783"
    ]
    const backgroundColor = [
      "#FCECE7",
      "#EBECF0",
      "#D8EEFB",
      "#FEFAE8",
      "#EAFCFF",
      "#E9E7FD",
      "#E3FCEF",
      "#FFC8E9"
    ]
    const colorIndex = this.cycleList.findIndex((cycle) => cycle.cutOffTime === time);
    return {
      label: label,
      color: colorIndex >= textColor.length ? "#4D4D4D" : textColor[colorIndex],
      background: colorIndex >= backgroundColor.length ? "#EBECF0" : backgroundColor[colorIndex]
    }
  }

  showActualTotalQuantity(merchant: KulionerMerchant) {
    return merchant.totalQuantity !== merchant.actualQuantity && merchant.isPurchased;
  }

  showActualTotalProduct(merchant: KulionerMerchant) {
    return merchant.totalProduct !== merchant.actualProduct && merchant.isPurchased;
  }
  
  mapStatusProduct(merchant: KulionerMerchant) {
    if (!merchant.isPurchased) return {
      label: "Belum dibeli",
      textColor: "text-gray-lp-600"
    }

    const isSoldOut = merchant.actualQuantity === 0;
    const isAllSold = merchant.actualQuantity === merchant.totalQuantity;
    const label = isSoldOut ? "Stok habis" : `Sudah dibeli ${merchant.actualQuantity}/${merchant.totalQuantity}`;
    const textColor = isSoldOut ? "text-red-lp-510" : isAllSold ? "text-green-lp-100" : "text-yellow-lp-500";


    return {
      label: label,
      textColor: textColor
    }
  }

  get isEligibleProcessOrderByCustomer() {
    return this.slicedMerchant.every((merchant: KulionerMerchant) => merchant.isPurchased) && this.slicedMerchant.some((merchant: KulionerMerchant) => merchant.actualQuantity)
  }

  get cycleList() {
    return KulionerController.cycles;
  }
}
export default CardListKulioner;
